<template>
<div>
    <page-title-bar></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
        <v-layout row wrap justify-center>
            <v-flex xs12>
                <app-card>
                    <app-section-loader :status="loading.getLogs"></app-section-loader>
                    <v-card-title>
                        <v-layout row>
                            <v-flex auto class="pa-0">
                                <h4>LỊCH SỬ HOẠT ĐỘNG</h4>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card class="mt-4">
                        <v-data-table
                            :headers="headers"
                            :items="items"
                            :rows-per-page-items="rowPerPage"
                            disable-initial-sort
                        >
                            <template #headers="props">
                                <tr>
                                    <th :class="`text-xs-${header.align} fw-bold`" v-for="header in props.headers" :key="header.text">
                                        {{ header.text }}
                                    </th>
                                </tr>
                            </template>
                            <template #items="props">
                                <tr style="">
                                    <td class="text-no-wrap text-center">{{ props.item.createdAt | formatTimeDetail }}</td>
                                    <td v-if="props.item.user" class="text-no-wrap text-center">{{ props.item.user.name || props.item.user.username }}</td>
                                    <td class="text-no-wrap text-left">{{ props.item.action | translateText }}</td>
                                    <td class="text-no-wrap text-left">{{ props.item.receipt_type | translateText }}</td>
                                    <td class="text-no-wrap text-left text-no-wrap">{{ props.item.receipt_id }}</td>
                                    <td class="text-no-wrap text-left">{{ props.item.description }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                </app-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>
<script>
import api from '../../api';
export default {
    name: "logs",
    data(){
        return {
            loading: {
                getLogs: false
            },
            headers: [
                { text: "Thời gian", align: "center", value: "createdAt" },
                { text: "Tên người dùng", align: "center", value: "username" },
                { text: "Hành động", align: "left", value: "action" },
                { text: "Loại chứng từ", align: "left", sortable: false, value: "receipt_type" },
                { text: "Mã chứng từ", align: "left", value: "receipt_id" },
                { text: "Ghi chú", align: "left", value: "description" },
            ],
            items: [],
            rowPerPage: [20,50,100,{"text":"Tất cả","value":-1}],
        }
    },
    created(){
        this.getLogs();    
    },
    methods: {
        async getLogs() {
            this.$store.commit('loading', true)

            const data = await api.getLogs("limit=500");
            if (data.status === 200){
                this.items = data.data.map(log => log);
            }

            this.$store.commit('loading', false)
        }
    },
}
</script>